// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FaqAccordion-block-g0k6A {
  --red: #e8232b;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  max-width: 820px;
  margin: 0 auto;
}

.FaqAccordion-heading-cbtNT {
  font-size: clamp(24px, 4vw, 34px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 28px;
}

.FaqAccordion-item-XVMIv {
  border: 1px solid var(--line);
  border-radius: 14px;
  margin-bottom: 12px;
  background: #fff;
  overflow: hidden;
}

.FaqAccordion-qHead-aYdxH {
  margin: 0;
}

.FaqAccordion-qBtn-fcBsO {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 16px;
  text-align: left;
  background: none;
  border: 0;
  cursor: pointer;
  padding: 18px 20px;
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
  font-family: inherit;
  min-height: 44px;
}

.FaqAccordion-qBtn-fcBsO:hover {
  color: var(--red);
}

.FaqAccordion-qBtn-fcBsO:focus-visible {
  outline: 2px solid var(--red);
  outline-offset: -2px;
}

.FaqAccordion-chev-riuup {
  width: 20px;
  height: 20px;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  color: var(--muted);
  -webkit-transition: -webkit-transform 0.18s ease;
  transition: -webkit-transform 0.18s ease;
  transition: transform 0.18s ease;
  transition: transform 0.18s ease, -webkit-transform 0.18s ease;
}

.FaqAccordion-chevOpen-5fT41 {
  -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
          transform: rotate(180deg);
}

.FaqAccordion-panel-VM218 {
  padding: 0 20px 18px;
}

.FaqAccordion-panel-VM218 p {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: var(--muted);
}

@media (prefers-color-scheme: dark) {
  .FaqAccordion-block-g0k6A,
  .FaqAccordion-heading-cbtNT {
    color: #f3f4f6;
  }
  .FaqAccordion-item-XVMIv {
    background: #1d2125;
    border-color: #2c3137;
  }
  .FaqAccordion-qBtn-fcBsO {
    color: #f3f4f6;
  }
  .FaqAccordion-panel-VM218 p {
    color: #9aa3ad;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/marketing/FaqAccordion.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AACA;EACE,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AACA;EACE,iBAAiB;AACnB;;AACA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,mBAAmB;EACnB,gDAAgC;EAAhC,wCAAgC;EAAhC,gCAAgC;EAAhC,8DAAgC;AAClC;;AACA;EACE,iCAAyB;MAAzB,6BAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".block {\n  --red: #e8232b;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  max-width: 820px;\n  margin: 0 auto;\n}\n\n.heading {\n  font-size: clamp(24px, 4vw, 34px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 28px;\n}\n\n.item {\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  margin-bottom: 12px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.qHead {\n  margin: 0;\n}\n.qBtn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  text-align: left;\n  background: none;\n  border: 0;\n  cursor: pointer;\n  padding: 18px 20px;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--ink);\n  font-family: inherit;\n  min-height: 44px;\n}\n.qBtn:hover {\n  color: var(--red);\n}\n.qBtn:focus-visible {\n  outline: 2px solid var(--red);\n  outline-offset: -2px;\n}\n\n.chev {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 auto;\n  color: var(--muted);\n  transition: transform 0.18s ease;\n}\n.chevOpen {\n  transform: rotate(180deg);\n}\n\n.panel {\n  padding: 0 20px 18px;\n}\n.panel p {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--muted);\n}\n\n@media (prefers-color-scheme: dark) {\n  .block,\n  .heading {\n    color: #f3f4f6;\n  }\n  .item {\n    background: #1d2125;\n    border-color: #2c3137;\n  }\n  .qBtn {\n    color: #f3f4f6;\n  }\n  .panel p {\n    color: #9aa3ad;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `FaqAccordion-block-g0k6A`,
	"heading": `FaqAccordion-heading-cbtNT`,
	"item": `FaqAccordion-item-XVMIv`,
	"qHead": `FaqAccordion-qHead-aYdxH`,
	"qBtn": `FaqAccordion-qBtn-fcBsO`,
	"chev": `FaqAccordion-chev-riuup`,
	"chevOpen": `FaqAccordion-chevOpen-5fT41`,
	"panel": `FaqAccordion-panel-VM218`
};
module.exports = ___CSS_LOADER_EXPORT___;
